export default function Error() {
  return (
    <div className="container mx-auto p-8">
      <h2>Something went wrong!</h2>
    </div>
  );
}
